import { StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  storeContainerStyle: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    borderColor: theme.colors.borderColorEight,
    borderWidth: 1,
    borderRadius: 6.2,
    paddingHorizontal: 15,
    paddingTop: 8.3,
    paddingBottom: 12.5,
    marginTop: 22.6,
    marginBottom: 12.5,
  }),
  storeIconStyle: {
    marginRight: 8,
  },
  infoContainerStyle: {
    flex: 1,
  },
  storeNameTextStyle: theme => ({
    fontSize: 14.6,
    lineHeight: 20.8,
    color: theme.colors.headerTitleColor,
    ...Fonts.type.bold,
  }),
  storeInfoTextStyle: theme => ({
    fontSize: 14.6,
    lineHeight: 20.8,
    color: theme.colors.headerTitleColor,
  }),
})
